import { ReactElement } from "react";
import { useEmbedded } from "~/hooks/embedded";

export function HideWhenEmbedded(props: {
  children: ReactElement | ReactElement[];
}) {
  const { isEmbedded } = useEmbedded();

  if (isEmbedded) return <></>;

  return <>{props.children}</>;
}
